<template>
  <v-row class="d-flex justify-center mt-0 mb-4">
    <v-col cols="12" class="pb-sm-16 mb-xl-16 mb-md-4">
      <div
        class="body-1 text-center"
        style="cursor: default"
      >
        Usuario: {{ $store.state.user.nombre }} {{ $store.state.user.apellido }}
      </div>
    </v-col>
    <v-col
        v-for="(card, index) in cards"
        :key="index"
        class="px-xl-0"
        cols="12"
        sm="4"
        :class="card.class"
      >
      <v-hover v-slot="{ hover }">
        <v-card
          style="cursor: pointer"
          height="200"
          :width="$vuetify.breakpoint.xl ? 300 : 275"
          :elevation="hover ? 12 : 2"
          :title="card.hover"
          :class="hover ? `ma-2 ${card.color}` : ''"
          @click="open(card.path)"
        >
          <v-card-text class="text-center">
            <div
              class="text-h5 mb-4"
              :class="hover ? 'white--text' : ''"
            >
              <span v-html="card.title"></span>
            </div>
            <v-icon
              size="80"
              :color="hover ? 'white' : ''"
            >
              {{ card.icon }}
            </v-icon>
          </v-card-text>
        </v-card>
      </v-hover>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      cards: [
        {
          class: 'd-flex justify-md-end justify-center',
          title: 'Turnos',
          hover: 'ABM de turnos',
          color: 'purple lighten-1',
          icon: 'fas fa-headset',
          path: '/turnos'
        },
        {
          class: 'd-flex justify-center',
          title: 'Turnos Postventa',
          hover: 'Turnero de postventa',
          color: 'green',
          icon: 'fas fa-car-side',
          path: '/turnos-postventa'
        },
        // {
        //   class: 'd-flex justify-md-start justify-center',
        //   title: 'Turnos Entrega',
        //   hover: 'Turnero de entrega',
        //   color: 'amber',
        //   icon: 'fas fa-handshake',
        //   path: '/turnos-entrega'
        // }
      ]
    }
  },
  methods: {
    open (ruta) {
      const routeData = this.$router.resolve({ path: ruta })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
